/**
 * @generated SignedSource<<2c785728b68ef1c72ee8f744280bc844>>
 * @relayHash 13d2e764491c2db210de5983be533574
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 15a0c47416d8e5bf0faf0c0c837986c9c86f583f39915de05768645f02ab1a9b

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { FieldsPageViewQuery } from './FieldsPageViewQuery.graphql';

const node: PreloadableConcreteRequest<FieldsPageViewQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "15a0c47416d8e5bf0faf0c0c837986c9c86f583f39915de05768645f02ab1a9b",
    "metadata": {},
    "name": "FieldsPageViewQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
